module.exports = "https://www.gc-pro.gnp.com.mx/3fb0c867c3a0d68f3acc017b5991b1be.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/unchecked.svg
// module id = 8169
// module chunks = 0